import { InjectionToken } from '@angular/core';

export const CHAT_DATA_RETRIEVAL_BASE_ROUTER_PATH = new InjectionToken<string[]>(
	'CHAT_DATA_RETRIEVAL_BASE_ROUTER_PATH',
	{
		factory: () => ['/', 'home', 'chat'],
	}
);
